<template>
  <div>
    <b-table
      v-if="relatedFiles.length"
      ref="refRelatedFilesTable"
      class="position-relative event_list shadow-table bg-white"
      :items="relatedFiles"
      responsive
      :fields="tableColumns"
      primary-key="id"
      :sort-by.sync="sortBy"
      show-empty
      no-sort-reset
      empty-text="No matching records found"
      :sort-desc.sync="isSortDirDesc"
    >
      <!-- Column: Role -->
      <template #cell(fileNo)="data">
        <div class="text-nowrap">
          <b-button
            v-if="canViewThisAction('show', 'File')"
            v-ripple.400="'rgba(30, 30, 30, 0.15)'"
            variant="link"
            class="weight-600 align-middle detail-view-id"
            :to="{ name: 'customers-files-show', params: { id: data.item.fileID } }"
          >
            {{ data.item.fileNo }}
          </b-button>
          <b-button
            v-else
            v-ripple.400="'rgba(30, 30, 30, 0.15)'"
            variant="none"
            class="text-bold-black align-middle detail-view-id not-button"
          >
            {{ data.item.fileNo }}
          </b-button>
        </div>
      </template>

      <template #cell(nvsFileType)="data">
        <div class="text-nowrap">
          <span class="">{{ data.item.nvsFileType }}</span>
          <br>
          <span
            v-if="data.item.lotLocation"
            class=""
          >
            {{ data.item.lotLocation }}
          </span>
        </div>
      </template>

      <template #cell(purchasers)="data">
        <div
          v-for="(purchaser, key) in data.item.purchasers"
          :key="key"
          class=""
        >
          <b-button
            v-if="canViewThisAction('show', 'Customer') && purchaser.customer"
            v-ripple.400="'rgba(30, 30, 30, 0.15)'"
            variant="link"
            class="weight-600 align-middle detail-view-id text-uppercase"
            :to="{ name: 'customers-customers-show', params: { id: purchaser.customer } }"
          >
            {{ purchaser.name }}
          </b-button>
          <b-button
            v-else
            v-ripple.400="'rgba(30, 30, 30, 0.15)'"
            variant="none"
            class="text-bold-black align-middle not-button text-uppercase"
          >
            {{ purchaser.name }}
          </b-button>
          <br>
          <span
            v-if="purchaser.encryptedNric"
            class=""
          >
            {{ purchaser.encryptedNric }}
          </span>
        </div>
      </template>

      <!-- Column: Status -->
      <template #cell(nvsFileStatus)="data">
        <b-badge
          :variant="`light-${resolveFileStatusVariant(data.item.nvsFileStatus)}`"
          class="text-capitalize"
        >
          {{ data.item.nvsFileStatus }}
        </b-badge>
      </template>

      <template #cell(confirmDate)="data">
        <div class="text-nowrap">
          <span class="">{{ data.item.confirmDate ? dateFormat(data.item.confirmDate) : '-' }}</span>
        </div>
      </template>

      <!-- Column: Status -->
      <template #cell(paymentStatus)="data">
        <b-badge
          :variant="`light-${resolvePaymentStatusVariant(data.item.paymentStatus)}`"
          class="text-capitalize"
        >
          {{ data.item.nvsFileStatus && data.item.nvsFileStatus.toLowerCase() === 'book' ? 'Booking Fee' : data.item.paymentStatus || '-' }}
        </b-badge>
      </template>

      <template #cell(agent)="data">
        <div class="text-nowrap">
          <span class="">{{ getAgentData(data.item.agents, 'name') }}</span>
          <br>
          <span class="">{{ getAgentData(data.item.agents, 'code') }}</span>
        </div>
      </template>
    </b-table>
    <div
      v-else
      class="empty_block"
    >
      <h4>No related files found.</h4>
    </div>
  </div>
</template>

<script>
import {
  BTable, BButton, VBTooltip, BBadge,
} from 'bootstrap-vue'
import store from '@/store/index'
import Ripple from 'vue-ripple-directive'
import moment from 'moment'
import { useUtils as useAclUtils } from '@/libs/acl/custom'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import ToastificationContentCustom from '../../../operation/ToastificationContentCustom.vue'

const { canViewThisAction } = useAclUtils()

export default {
  components: {
    BTable,
    BButton,
    BBadge,
  },
  directives: {
    'b-tooltip': VBTooltip,
    Ripple,
  },
  props: {
    relatedFiles: {
      type: [Array, null],
      default: () => [],
    },
  },
  data() {
    return {
      user: store.state.auth.userData,
      render: false,
      sortBy: 'id',
      sortDesc: false,
      isSortDirDesc: true,
      tableItems: [],
      currentPage: 1,
      totalRows: 0,
      perPage: 10,
      customerNameVal: '',
      customerEmailVal: '',
      hasEmailAddress: '',
      customerContactVal: '',
      statementMessage: '',
      fileType: '',
      fileNumber: '',
      fileID: '',
      tableColumns: [
        {
          key: 'fileNo',
          label: 'File No.',
          sortable: false,
        },
        {
          key: 'nvsFileType',
          label: 'Product Description',
          sortable: false,
        },
        {
          key: 'purchasers',
          label: 'customer',
          sortable: false,
        },
        {
          key: 'nvsFileStatus',
          label: 'file status',
          sortable: false,
        },
        {
          key: 'paymentStatus',
          label: 'payment status',
          sortable: false,
        },
        {
          key: 'confirmDate',
          label: 'confirm date',
          sortable: false,
        },
        {
          key: 'agent',
          label: 'service agent',
          sortable: false,
        },
      ],
    }
  },

  methods: {
    canViewThisAction,
    resolveFileStatusVariant(status) {
      if (status === 'OPEN') return 'warning'
      if (status === 'BOOK') return 'info'
      return 'success'
    },
    openEmailStatementModal(item) {
      if (item.purchasers && item.purchasers.length) {
        const firstPurchaser = item.purchasers[0]
        this.hasEmailAddress = firstPurchaser.email ? firstPurchaser.email : ''
        this.customerNameVal = firstPurchaser.name ? firstPurchaser.name : ''
        this.customerEmailVal = firstPurchaser.email ? firstPurchaser.email : ''
        this.customerContactVal = firstPurchaser.contact ? firstPurchaser.contact : ''
        this.fileType = (item.file && item.nvsFileType) ? item.nvsFileType : ''
        this.fileNumber = item.fileNo ? item.fileNo : ''
        this.fileID = item.fileID ? item.fileID : ''
        this.statementMessage = `Here is the Statement of Account for your purchase with us for ${this.fileType} (file no.: ${item.fileNo}), as at ${moment().format('DD MMM YYYY')}. The statement provides a detailed summary of your transactions and current account balance.

Please be informed that the PDF is password-protected using your mobile number (e.g. 912345678).`
        this.$root.$emit('bv::show::modal', 'email-statement-modal', '')
      } else {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Purchaser Data is missing',
            icon: 'AlertTriangleIcon',
            variant: 'danger',
          },
        })
      }
    },
    closeStatementModal() {
      this.$root.$emit('bv::hide::modal', 'email-statement-modal', '')
    },
    getAgentData(agents, field) {
      const mainAgentData = agents.find(agent => agent.type === 'Sales & Service Agent' || agent.type === 'Service Agent')
      if (mainAgentData && mainAgentData[field]) return mainAgentData[field]

      return ''
    },
    resolvePaymentStatusVariant(status) {
      if (status === 'Fully Paid') return 'success'
      if (status === 'Ongoing Installment') return 'info'
      if (status === 'Pending Payment') return 'warning'
      if (status === 'Reactivation Fee') return 'danger'
      return 'secondary'
    },
    sendEmailStatement() {
      let contact = this.customerEmailVal
      if (this.customerContactVal) {
        contact = this.customerContactVal.slice(-8)
      }
      const formData = new FormData()
      formData.append('customerName', this.customerNameVal)
      formData.append('customerEmail', this.customerEmailVal)
      formData.append('message', this.statementMessage)
      formData.append('fileType', this.fileType)
      formData.append('fileNo', this.fileNumber)
      formData.append('contact', contact)
      formData.append('fileID', this.fileID)
      formData.append('url', `${window.location.origin}`)

      this.$http.post('customer/files/send/soa/statement', formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
      })
        .then(response => {
          if (response.data.success) {
            this.$toast({
              component: ToastificationContentCustom,
              props: {
                title: 'Statement of Account Email Sent',
                text: response.data.message,
                icon: 'CheckCircleIcon',
                variant: 'success',
                hideClose: true,
              },
            })
          } else {
            this.$toast({
              component: ToastificationContent,
              props: {
                title: response.data.message ?? process.env.VUE_APP_DEFAULT_ERROR_MESSAGE,
                icon: 'AlertTriangleIcon',
                variant: 'danger',
              },
            })
          }
        })
        .catch(error => {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: error.data.message ?? process.env.VUE_APP_DEFAULT_ERROR_MESSAGE,
              icon: 'AlertTriangleIcon',
              variant: 'danger',
            },
          })
        })
    },
  },
}
</script>
